<div class="root">
  <div class="icon">
    <app-lucide-icon [iconName]="iconName" [size]="32" [color]="'secondary'"></app-lucide-icon>
  </div>

  <div class="text-container">
    <span class="text">{{ firstText }}</span>

    <ng-container *ngIf="isLink">
      <a *ngIf="!isExternalLink" class="content link" [routerLink]="[linkRoute]">{{ secondText }}</a>

      <a *ngIf="isExternalLink" class="content link" [href]="linkRoute" target="_blank">{{ secondText }}</a>
    </ng-container>

    <span *ngIf="!isLink" class="text content">{{ secondText }}</span>
  </div>
</div>